import * as React from 'react'

function Pages(props) {
  return (
    <svg
      width={40}
      height={48}
      viewBox="0 0 52 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: 'scale(2) translateY(2px)', transformOrigin: 'top left' }}
      {...props}
    >
      <rect
        width="12"
        height="16"
        rx="2"
        transform="matrix(-1 0 0 1 12 8)"
        fill="#F0C266"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 0C19.1046 0 20 0.895431 20 2V14C20 15.1046 19.1046 16 18 16H14V10C14 7.79086 12.2091 6 10 6H8V2C8 0.895431 8.89543 0 10 0H18Z"
        fill="#F0C266"
      />
    </svg>
  )
}

export default Pages
